import {API} from "./API";
import {Employee} from "../models/Employee";

export class EmployeesAPI extends API<Employee> {

	constructor () {
		super("employees");
    }
}
